import { gql, useQuery } from '@apollo/client';

import {
  userDraftAnnouncementOptions_GroupQuery,
  userDraftAnnouncementOptions_GroupQueryVariables,
} from './graphql-types/userDraftAnnouncementOptions_GroupQuery';

const GROUP_QUERY = gql`
  query userDraftAnnouncementOptions_GroupQuery($input: GroupInput!) {
    group(input: $input) {
      result {
        _id
        currentUserGroupPermission {
          canAnnounceDraftPost
        }
      }
    }
  }
`;

export const useDraftAnnouncementOptions = (options: {
  isEditing: boolean;
  isPublished: boolean;
  groupId?: string;
}): {
  showAnnouncementOption: boolean;
} => {
  const { data, loading } = useQuery<
    userDraftAnnouncementOptions_GroupQuery,
    userDraftAnnouncementOptions_GroupQueryVariables
  >(GROUP_QUERY, {
    variables: { input: { _id: options.groupId } },
    skip: !options.groupId || (options.isEditing && options.isPublished),
  });

  const showAnnouncementOption =
    !options?.groupId || (options.isEditing && options.isPublished)
      ? false
      : loading
      ? false
      : !!data?.group.result?.currentUserGroupPermission?.canAnnounceDraftPost;

  return { showAnnouncementOption };
};
